import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { paths } from "@libs/paths";
import styles from "./index.module.css";
import type { NextPage } from "next";

const CommercialNotice: NextPage = () => {
  return (
    <CommonLayout hasFooter>
      <CommonHead
        title={"特定商取引法に基づく表記"}
        ogUrl={paths.commercialNotice}
      />
      <main className={styles.inner}>
        <h1 className={styles.title}>特定商取引法に基づく表記</h1>
        <dl>
          <div className={styles.item}>
            <dt>支払い時期・方法</dt>
            <dd>予約確定時にクレジットカードもしくは、当日現地での支払い</dd>
            <dd>※現地での支払い方法についてはお店にお問い合わせください。</dd>
          </div>
          <div className={styles.item}>
            <dt>商品の引渡時期</dt>
            <dd>店舗来店時</dd>
          </div>
          <div className={styles.item}>
            <dt>事業者の氏名（名称）、住所、電話番号</dt>
            <dd>
              事業者名・代表者または業務責任者につきましては店舗へお問い合わせください。
            </dd>
          </div>
        </dl>
      </main>
    </CommonLayout>
  );
};

export default CommercialNotice;
